module.exports = __webpack_public_path__ + "media/images/main/New-Art-animation-62e9a1cc7f54b0f070320bfbf282040b.gif";